import {Layout} from "antd";
import {Outlet, useLocation} from "@tanstack/react-router";
import SignInOut from "./SignInOut.tsx";
import LogoRaiders from "./LogoRaiders.tsx";
import MobileMenuToggle from "./MobileMenuToggle.tsx";
import NavBar from "./NavBar.tsx";
import {buildMenuItems} from "./NavItemBuilder.ts";
import {NavSider} from "./NavSider.tsx";

export default function BaseLayout() {
  const {Header, Content} = Layout;
  const location = useLocation();
  const items = buildMenuItems();
  return (
      <div
          className={
            "bg-[var(--ant-color-bg-base)] grid grid-rows-[auto_1fr] h-screen"
          }
      >
        <Layout className={
            "pt-[69px]! " +
            "sm:pt-[94px]! " +
            "lg:pt-[124px]! " +
            "xl:pr-[124px]! " +
            "duration-300! "
        }>
          <div className={"bg"}/>
          {/*<HeaderSideWrapper />*/}
          <Header
              className={
                  "fixed items-center " +
                  "top-0 left-0 right-0 z-10 flex gap-10 rounded-none " +
                  "sm:top-3 sm:right-4 sm:left-4 sm:rounded-lg " +
                  "lg:top-4 lg:right-7 lg:left-7 lg:rounded-lg duration-300"
              }
              style={{
                paddingInline: 16,
              }}
          >
            {/* Auf kleinen Screens: Burger-Button */}
            <MobileMenuToggle/>
            <LogoRaiders/>
            <NavBar menuItems={items} selectedKey={location.pathname}/>
            <SignInOut/>
          </Header>
          <NavSider selectedKey={location.pathname} menuItems={items}/>
        </Layout>

        <Content
            className={
                "w-full h-full " +
                "pr-1 pl-1 pt-[0px] " +
                "sm:pr-4 sm:pl-4 " +
                "lg:pr-16 lg:pl-16 " +
                "xl:pl-[124px] " +
                "duration-300 relative"
            }
        >
          <Outlet/>
        </Content>
      </div>
  );
}
